import { GatsbyImage as Img } from 'gatsby-plugin-image';
import React from 'react';
import { ImageType } from 'utils/types';

import * as S from './styles';

export interface OneImageDisplayProps {
  mobileImages: ImageType[];
  desktopImages: ImageType[];
  hasOnlyOneImage: boolean;
}

export const OneImageDisplay: React.FC<OneImageDisplayProps> = ({
  desktopImages,
  mobileImages,
  hasOnlyOneImage,
}) => (
  <S.ColContainer xs={12} md={5} hasOnlyOneImage={hasOnlyOneImage}>
    <S.MobileOneImageContainer>
      {mobileImages[0] ? (
        <S.MobileAnimatedImage aria-hidden="true">
          <Img
            image={mobileImages[0].gatsbyImageData}
            alt={mobileImages[0].description || ''}
            style={{ maxHeight: '412px' }}
            imgStyle={{ objectFit: 'contain' }}
          />
        </S.MobileAnimatedImage>
      ) : null}
    </S.MobileOneImageContainer>
    <S.DesktopOneImageContainer>
      {desktopImages[0] ? (
        <div aria-hidden="true">
          <Img
            image={desktopImages[0].gatsbyImageData}
            alt={desktopImages[0].description || ''}
          />
        </div>
      ) : null}
    </S.DesktopOneImageContainer>
  </S.ColContainer>
);
